/*
  PDP v2 · Buy box
  Gallery (thumbs, fade, swipe, images that follow the size), size cards,
  price / per-oz / button price, free-shipping bar, gift hint, coupon code
  label, sticky mobile bar, w_view_item.
  Add to cart itself is handled by assets/pdp-v2-cart.js (QOTTv2).
*/
(() => {
    // ---- w_view_item: once per page load (unchanged from v1) ----
    if (!window.__qv2ViewItemSent) {
        window.__qv2ViewItemSent = true;
        window.dataLayer = window.dataLayer || [];
        document.querySelectorAll('.qv2-bb [data-view-item-payload]').forEach(node => {
            try {
                const payload = JSON.parse(node.textContent);
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(payload);
            } catch (err) {
                console.error('w_view_item: could not parse product payload', err);
            }
        });
    }

    const money = (cents, currency) => (window.QOTTv2 && window.QOTTv2.formatMoney)
        ? window.QOTTv2.formatMoney(cents, currency)
        : '$' + ((Number(cents) || 0) / 100).toFixed(2);

    const init = (section) => {
        if (!section || section.dataset.qv2Ready) return;
        section.dataset.qv2Ready = 'true';

        let data = { variants: [] };
        const dataNode = section.querySelector('script[data-qv2-product]');
        try { if (dataNode) data = JSON.parse(dataNode.textContent); } catch (err) { console.error('pdp-buy-box-v2: bad product JSON', err); }
        const variantById = new Map((data.variants || []).map(v => [String(v.id), v]));

        // ================= GALLERY =================
        const stage = section.querySelector('[data-qv2-stage]');
        const slides = [...section.querySelectorAll('[data-qv2-slide]')];
        const thumbs = [...section.querySelectorAll('[data-qv2-thumb]')];
        const thumbsWrap = section.querySelector('[data-qv2-thumbs-wrap]');
        const thumbsTrack = section.querySelector('[data-qv2-thumbs]');

        const visibleIndexes = () => slides.map((s, i) => (s.hidden ? -1 : i)).filter(i => i > -1);
        const activeIndex = () => slides.findIndex(s => s.classList.contains('is-active'));

        const pauseVideos = () => slides.forEach(s => s.querySelectorAll('video').forEach(v => { try { v.pause(); } catch (err) {} }));

        const show = (index) => {
            if (index < 0 || index >= slides.length) return;
            pauseVideos();
            slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
            thumbs.forEach((t, i) => {
                t.classList.toggle('is-active', i === index);
                t.setAttribute('aria-current', i === index ? 'true' : 'false');
            });
            const thumb = thumbs[index];
            if (thumb && thumbsTrack) {
                const horizontal = getComputedStyle(thumbsTrack).flexDirection === 'row';
                const t = thumb.offsetTop - thumbsTrack.offsetTop;
                const l = thumb.offsetLeft - thumbsTrack.offsetLeft;
                if (horizontal) {
                    if (l < thumbsTrack.scrollLeft || l + thumb.offsetWidth > thumbsTrack.scrollLeft + thumbsTrack.clientWidth) {
                        thumbsTrack.scrollTo({ left: l - 16, behavior: 'smooth' });
                    }
                } else if (t < thumbsTrack.scrollTop || t + thumb.offsetHeight > thumbsTrack.scrollTop + thumbsTrack.clientHeight) {
                    thumbsTrack.scrollTo({ top: t - 16, behavior: 'smooth' });
                }
            }
        };

        thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));

        const step = (dir) => {
            const visible = visibleIndexes();
            if (!visible.length) return;
            const pos = visible.indexOf(activeIndex());
            const next = visible[(pos + dir + visible.length) % visible.length];
            show(next);
        };

        // swipe on the main image (mainly mobile)
        if (stage) {
            let startX = null;
            let startY = null;
            stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
            stage.addEventListener('touchend', (e) => {
                if (startX === null) return;
                const dx = e.changedTouches[0].clientX - startX;
                const dy = e.changedTouches[0].clientY - startY;
                if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
                startX = null;
            }, { passive: true });
        }

        // thumb strip arrows + edge state (from v1, axis-agnostic)
        if (thumbsWrap && thumbsTrack) {
            const horizontal = () => getComputedStyle(thumbsTrack).flexDirection === 'row';
            const updateNav = () => {
                const h = horizontal();
                const pos = h ? thumbsTrack.scrollLeft : thumbsTrack.scrollTop;
                const size = h ? thumbsTrack.scrollWidth : thumbsTrack.scrollHeight;
                const client = h ? thumbsTrack.clientWidth : thumbsTrack.clientHeight;
                thumbsWrap.classList.toggle('has-more-above', pos > 2);
                thumbsWrap.classList.toggle('has-more-below', pos < size - client - 2);
            };
            const amount = () => {
                const t = thumbs.find(x => !x.hidden);
                if (!t) return 100;
                const r = t.getBoundingClientRect();
                return (horizontal() ? r.width : r.height) + 12;
            };
            thumbsWrap.querySelectorAll('[data-qv2-thumb-nav]').forEach(btn => {
                btn.addEventListener('click', () => {
                    const dir = btn.dataset.qv2ThumbNav === 'prev' ? -1 : 1;
                    thumbsTrack.scrollBy(horizontal() ? { left: dir * amount(), behavior: 'smooth' } : { top: dir * amount(), behavior: 'smooth' });
                });
            });
            thumbsTrack.addEventListener('scroll', updateNav, { passive: true });
            window.addEventListener('resize', updateNav);
            section._qv2UpdateNav = updateNav;
            updateNav();
        }

        // show only the media for the selected size
        const filterGallery = (variantId) => {
            if (!data.followSize) return;
            const token = ',' + variantId + ',';
            let firstVisible = -1;
            slides.forEach((s, i) => {
                const list = s.dataset.variants || '';
                const visible = !list || list.includes(token);
                s.hidden = !visible;
                if (thumbs[i]) thumbs[i].hidden = !visible;
                if (visible && firstVisible === -1) firstVisible = i;
            });
            if (firstVisible > -1) show(firstVisible);
            if (section._qv2UpdateNav) section._qv2UpdateNav();
        };

        // ================= SIZES / PRICE =================
        const form = section.querySelector('form[data-qv2-add-form]');
        const idInput = section.querySelector('[data-qv2-variant-input]');
        const sizeButtons = [...section.querySelectorAll('[data-qv2-size]')];
        const priceEl = section.querySelector('[data-qv2-price]');
        const compareEl = section.querySelector('[data-qv2-compare]');
        const perOzEl = section.querySelector('[data-qv2-per-oz]');
        const submitBtn = section.querySelector('[data-qv2-submit]');
        const submitLabel = section.querySelector('[data-qv2-submit-label]');
        const stickyMeta = section.querySelector('[data-qv2-sticky-meta]');
        const giftHint = section.querySelector('[data-qv2-gift-hint]');
        const currency = data.currency;

        const offerConfig = (window.QOTTv2 && window.QOTTv2.config) ? window.QOTTv2.config() : {};
        const giftQualifies = ((offerConfig.gift && offerConfig.gift.qualifies) || []).map(String);

        const perOz = (v) => {
            const floz = parseFloat(v && v.floz);
            if (!data.showPerOz || !floz) return '';
            return money(Math.round(v.price / floz), currency) + ' ' + (data.perOzSuffix || '/ fl oz');
        };

        const applyVariant = (variantId, { filter = true } = {}) => {
            const v = variantById.get(String(variantId));
            if (!v) return;
            if (idInput) idInput.value = v.id;

            sizeButtons.forEach(b => {
                const on = b.dataset.variantId === String(v.id);
                b.classList.toggle('is-selected', on);
                b.setAttribute('aria-checked', on ? 'true' : 'false');
                b.tabIndex = on ? 0 : -1;
            });

            if (priceEl) priceEl.textContent = money(v.price, currency);
            if (compareEl) {
                if (v.compare > v.price) { compareEl.textContent = money(v.compare, currency); compareEl.hidden = false; }
                else compareEl.hidden = true;
            }
            if (perOzEl) perOzEl.textContent = perOz(v);

            if (submitBtn) submitBtn.disabled = !v.available;
            if (submitLabel) {
                submitLabel.textContent = v.available
                    ? (data.buttonLabel || 'Add to cart') + (data.showPriceOnButton ? ' · ' + money(v.price, currency) : '')
                    : (data.soldOutLabel || 'Sold out');
            }
            if (stickyMeta) stickyMeta.textContent = (v.label || v.title) + ' · ' + money(v.price, currency);
            if (giftHint) giftHint.hidden = giftQualifies.length === 0 || giftQualifies.includes(String(v.id));

            if (filter) filterGallery(v.id);

            try {
                const url = new URL(window.location.href);
                url.searchParams.set('variant', v.id);
                window.history.replaceState(window.history.state, '', url.toString());
            } catch (err) {}
        };

        sizeButtons.forEach((btn, i) => {
            btn.addEventListener('click', () => applyVariant(btn.dataset.variantId));
            // arrow keys move between sizes (radio group behaviour)
            btn.addEventListener('keydown', (e) => {
                if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(e.key)) return;
                e.preventDefault();
                const enabled = sizeButtons.filter(b => !b.disabled);
                const pos = enabled.indexOf(btn);
                const next = enabled[(pos + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + enabled.length) % enabled.length];
                if (next) { next.focus(); applyVariant(next.dataset.variantId); }
            });
        });

        // initial state: ?variant= in the URL wins, then the Liquid default
        let initial = idInput ? idInput.value : null;
        try {
            const fromUrl = new URLSearchParams(window.location.search).get('variant');
            const v = fromUrl && variantById.get(String(fromUrl));
            if (v && v.available) initial = v.id;
        } catch (err) {}
        if (initial) applyVariant(initial, { filter: String(initial) !== String(idInput && idInput.defaultValue) });
        if (perOzEl && initial) perOzEl.textContent = perOz(variantById.get(String(initial)));

        // coupon card shows the code that will actually be applied (URL code included)
        const couponCode = section.querySelector('[data-qv2-coupon-code]');
        if (couponCode && window.QOTTv2) {
            const code = window.QOTTv2.resolveCode();
            if (code) couponCode.textContent = code;
        }

        // ================= FREE SHIPPING BAR =================
        const bar = section.querySelector('[data-qv2-ship]');
        if (bar) {
            const threshold = parseFloat(bar.dataset.threshold) || 0;
            const deliveryDays = parseInt(bar.dataset.deliveryDays, 10) || 3;
            const progressText = bar.dataset.progressText || 'Add [amount] more for free shipping';
            const metText = bar.dataset.metText || 'Free delivery';
            const fill = bar.querySelector('[data-qv2-ship-fill]');
            const msg = bar.querySelector('[data-qv2-ship-msg]');

            const deliveryDate = () => {
                const d = new Date();
                let remaining = deliveryDays;
                while (remaining > 0) {
                    d.setDate(d.getDate() + 1);
                    const day = d.getDay();
                    if (day !== 0 && day !== 6) remaining--;
                }
                const n = d.getDate();
                const suffix = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
                return `${d.toLocaleDateString(undefined, { weekday: 'long' })} ${n}${suffix} ${d.toLocaleDateString(undefined, { month: 'long' })}`;
            };

            // Before anything is in the cart, show the gap for the selected size,
            // so "Add $30.02 more" matches what the visitor is looking at.
            const render = (cartCents, cur) => {
                const selected = variantById.get(String(idInput && idInput.value));
                const basis = cartCents > 0 ? cartCents : (selected ? selected.price : 0);
                const total = basis / 100;
                if (threshold <= 0 || total >= threshold) {
                    bar.classList.add('is-met');
                    if (fill) fill.style.width = '100%';
                    if (msg) { msg.textContent = ''; const s = document.createElement('strong'); s.textContent = metText; msg.append(s, ' ' + deliveryDate()); }
                } else {
                    bar.classList.remove('is-met');
                    if (fill) fill.style.width = Math.max(0, Math.min(100, (total / threshold) * 100)) + '%';
                    if (msg) {
                        const parts = progressText.split('[amount]');
                        msg.textContent = '';
                        const strong = document.createElement('strong');
                        strong.textContent = money(Math.round((threshold - total) * 100), cur || currency);
                        msg.append(parts[0] || '', strong, parts.slice(1).join('[amount]') || '');
                    }
                }
            };
            let lastCart = 0;
            let lastCurrency = currency;
            const refresh = () => {
                const get = window.QOTTv2 ? window.QOTTv2.getCart() : fetch('/cart.js').then(r => r.json());
                get.then(cart => { lastCart = cart.total_price || 0; lastCurrency = cart.currency; render(lastCart, lastCurrency); }).catch(() => render(0, currency));
            };
            document.addEventListener('qott:cart-updated', (e) => {
                const cart = e.detail && e.detail.cart;
                if (cart) { lastCart = cart.total_price || 0; lastCurrency = cart.currency; render(lastCart, lastCurrency); }
            });
            sizeButtons.forEach(b => b.addEventListener('click', () => render(lastCart, lastCurrency)));
            render(0, currency);
            refresh();
        }

        // ================= STICKY MOBILE BAR =================
        const sticky = section.querySelector('[data-qv2-sticky]');
        const stickyBtn = section.querySelector('[data-qv2-sticky-btn]');
        if (sticky && sticky.dataset.enabled === 'true' && submitBtn && 'IntersectionObserver' in window) {
            const io = new IntersectionObserver(([entry]) => {
                const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                sticky.classList.toggle('is-visible', past);
                sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
                if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
            });
            io.observe(submitBtn);
        }
        if (stickyBtn && form) {
            stickyBtn.addEventListener('click', () => {
                if (submitBtn && submitBtn.disabled) return;
                stickyBtn.classList.add('is-loading');
                const done = () => stickyBtn.classList.remove('is-loading');
                const observer = new MutationObserver(() => {
                    if (!submitBtn.classList.contains('is-loading')) { done(); observer.disconnect(); }
                });
                if (submitBtn) observer.observe(submitBtn, { attributes: true, attributeFilter: ['class'] });
                if (typeof form.requestSubmit === 'function') form.requestSubmit();
                else form.dispatchEvent(new Event('submit', { cancelable: true }));
                setTimeout(() => { done(); observer.disconnect(); }, 8000);
            });
        }

        // make sure the add-to-cart form is bound even if the cart script loaded first
        if (window.QOTTv2 && form) window.QOTTv2.bindForm(form);
    };

    const initAll = () => document.querySelectorAll('[data-qv2-buybox]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-qv2-buybox]')));
})();
